import styled, { keyframes, css } from "styled-components";

import {
  btnRotateAnim,
  whiteBgOnClickAnim,
  scaleOnClickAnim,
} from "../../animations";

const apearA = keyframes`
  0% {
    opacity: 0;
    animation-timing-function: cubic-bezier(0.33, 1, 0, 0);
  }
  100% {
    opacity: 1;
  }`;

const apearAnim = css`
  ${apearA}
`;
export const OuterBox = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  /* max-width: 70px; */
  /* font-size: 12px; */
  border-radius: 18px;

  max-width: 80px;
  height: 36px;
  font-size: 16px;
  ${(p) => (p.active ? "color: #233b50;" : "color: #4199ba;")};
  transition: all 0.167s;
  p {
    text-transform: uppercase;
    position: absolute;
    pointer-events: none;
  }
  /* @media only screen and (min-width: 375px) {
    max-width: 80px;
    height: 36px;
    font-size: 16px;
  } */
`;

export const TabBox = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
`;
export const Tab = styled.div`
  border: solid 3px #4199ba;
  border-radius: 18px;
  /* max-width: 70px; */
  width: 100%;
  /* height: 32px; */
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  animation: ${(p) => (p.active ? "tab" : null)};
  animation-duration: 0.167s;
  animation-fill-mode: forwards;
  opacity: 1;
  ${(p) => (p.active ? "background: #4199ba;" : "background: transparent;")};
  transition: all 0.167s;
  max-width: 80px;
  height: 36px;
  font-size: 16px;
  @keyframes tab {
    0% {
      opacity: 0;
      transform: scale(0.5);
    }
    29% {
      opacity: 1;
      animation-timing-function: cubic-bezier(0.17, 0.17, 0.2, 1);
    }
    100% {
      transform: scale(1);
      animation-timing-function: cubic-bezier(0.35, 0, 0.2, 1);
    }
  }
`;
export const Header = styled.div`
  font-size: 10px;
 grid-template-columns: 30% 34% 33%;
  display: grid;
  margin: 10px 0;
  grid-column-gap: 1.5%;
`;

export const Row = styled.div`
  font-size: 12px;
  display: grid;
  grid-template-columns:  30% 20% 44%;
  margin-bottom: 10px;
  line-height: 1.6;
  grid-column-gap: 3%;
  pointer-events: ${(p) => (p.soundPlayed ? "none" : "auto")};
  cursor: ${(p) => (p.cur ? "pointer" : "auto")};
`;

export const Exit = styled.div`
  border-radius: 50%;
  border: solid 3px #4199ba;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  animation: ${(p) =>
    p.close ? scaleOnClickAnim : p.aboveAnim ? btnRotateAnim : null};
  animation-duration: ${(p) => (p.close ? "0.333s" : "0.5")};
  animation-fill-mode: forwards;
  :after {
    content: "";
    position: absolute;
    height: 100%;
    width: 100%;
    background: #ffffff;
    border: solid 3px #ffffff;
    border-radius: 38px;
    opacity: 0;
    right: 50%;
    bottom: 50%;
    transform: translate(50%, 50%);
    animation: ${(p) => (p.close ? whiteBgOnClickAnim : null)};
    animation-duration: 0.5s;
    animation-fill-mode: forwards;
  }
  g {
    stroke: #4199ba;
  }
  /* @media only screen and (min-width: 375px) {
    width: 36px;
    height: 36px;
  } */
`;

export const StatBox = styled.div`
  /* opacity: 0;
  animation: ${(p) => (p.statAnim ? apearAnim : null)};
  animation-duration: 0.5s;
  animation-fill-mode: forwards; */
`;

export const Item = styled.div`
  text-overflow: ellipsis;
  overflow: hidden;
  width: 100%;

  ${(props) =>
    props.win
      ? "text-shadow:  0 0 5px #4199ba; filter: brightness(150%);"
      : "text-shadow:  none; filter: none;"}
  &&.profit {
    text-align: right;
    display: flex;
    justify-content: end;
    /* padding-right: 4px; */
  }
  &&.icon {
    display: flex;
    align-items: center;
  }
  .winAmount {
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    p{
      display: flex;
    }
  }
  svg {
    height: 11px;
    path {
      fill: #4199ba;
      /* stroke: #4199ba; */
    }
  }
`;
export const Title = styled.div`
  text-transform: uppercase;
`;
